// extracted by mini-css-extract-plugin
export var textInput = "_ik-0";